import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import "./DocumentViewerModal.css";

const DocumentViewerModal = (props) => {
    const docs = props.fileUrl && props.fileExt
        ? [{ uri: props.fileUrl, fileType: props.fileExt }]
        : [];

    return (
        <Modal enforceFocus={false}
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="document-viewer-title"
            aria-describedby="document-viewer-description"
        >
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 800, height: '90%', bgcolor: 'background.paper', boxShadow: 24, overflow: 'scroll', p: 1 }}>
                {docs.length > 0 && (
                    <DocViewer
                        key={props.fileUrl}
                        pluginRenderers={DocViewerRenderers}
                        documents={docs}
                        style={{ height: '100%', width: '100%' }}
                    />
                )}
            </Box>
        </Modal>
    );
}

export default DocumentViewerModal;
